/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import Slider from 'react-slick';
import { jsx, css } from '@emotion/core';
import { FaSpinner } from 'react-icons/fa';

import { primary_l50 } from '../lib/colors';

import SlickArrow from '../SlickArrow/SlickArrow';

import './ItemSlider.scss';

const ItemSlider = ({
  loading,
  title,
  primaryColor,
  uiVariant,
  children,
  ...props
}) => {
  const dotsStyle = css`
    .slick-dots {
      display: flex !important;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: -25px;

      li {
        display: block;
        margin: 0 5px;
        height: ${uiVariant === '1' ? '8px' : '10px'};
        width: ${uiVariant === '1' ? '8px' : '10px'};

        &.slick-active {
          height: ${uiVariant === '1' ? '12px' : '10px'};
          width: ${uiVariant === '1' ? '12px' : '10px'};

          .dot {
            height: ${uiVariant === '1' ? '12px' : '10px'};
            width: ${uiVariant === '1' ? '12px' : '10px'};
            background-color: ${primaryColor};
          }
        }

        .dot {
          padding: 0;
          height: ${uiVariant === '1' ? '8px' : '10px'};
          width: ${uiVariant === '1' ? '8px' : '10px'};
          background-color: ${uiVariant !== '1' ? 'transparent' : '#fff'};
          border: ${uiVariant !== '1' ? `1px solid ${primaryColor}` : 'none'};
          border-radius: ${uiVariant !== '2' ? '50%' : 0};

          &:before {
            content: none;
          }

          &:focus,
          &:hover,
          &.active {
            background-color: ${uiVariant !== '1'
              ? primaryColor
              : primary_l50(primaryColor)};
          }
        }
      }
    }
  `;

  const settings = {
    arrows: true,
    dots: true,
    customPaging: function(i) {
      return <button className="dot">{/* {i + 1} */}</button>;
    },
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: <SlickArrow primaryColor={primaryColor} uiVariant={uiVariant} />,
    nextArrow: <SlickArrow primaryColor={primaryColor} uiVariant={uiVariant} />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      //{ breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 567, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <div className="item-slider">
      {loading && (
        <div className="loading-slider">
          <FaSpinner className="pulse" /> Caricamento...
        </div>
      )}
      {title && <div className="title">{title}</div>}
      <Slider {...settings} css={dotsStyle}>
        {children}
      </Slider>
    </div>
  );
};

export default ItemSlider;
